// API設定
// 2026-07-11: 独自ドメイン api.ec-ax.com へ切替（workers.dev はCFボットチャレンジで昼間ブロックされるため）。
// 旧URL https://zaiko-api-sneakers.yachiken5-34e.workers.dev も引き続き稼働（ロールバック先）。
export const API_BASE_URL = import.meta.env.PROD
  ? 'https://api.ec-ax.com'
  : '';

